export const OfferUnsubscribeErrorViewStyles = {
  message:
    'my-5 text-xl font-regular text-goEasyGray900 text-center sm:text-left',
}
